var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/PencilLine"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 14H3C2.86739 14 2.74021 13.9473 2.64645 13.8535C2.55268 13.7598 2.5 13.6326 2.5 13.5V10.7071C2.5 10.6414 2.51293 10.5764 2.53806 10.5158C2.56319 10.4551 2.60002 10.4 2.64645 10.3535L10.1464 2.85354C10.2402 2.75977 10.3674 2.70709 10.5 2.70709C10.6326 2.70709 10.7598 2.75977 10.8536 2.85354L13.6464 5.64643C13.7402 5.7402 13.7929 5.86738 13.7929 5.99999C13.7929 6.13259 13.7402 6.25977 13.6464 6.35354L6 14Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.5 4.5L12 8",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.4994 14H5.99944L2.53125 10.5318",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.1f76dae1856dc80ec243a95271c8cf8b.svg";
export { ForwardRef as ReactComponent };